import { useId } from 'react';

export const IconCar = ({
  width = 20,
  height = 21,
  color = 'currentColor',
}) => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4 0.5H36C37.933 0.5 39.5 2.067 39.5 4V36C39.5 37.933 37.933 39.5 36 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4C0.500001 2.067 2.067 0.5 4 0.5Z'
      fill='white'
    />
    <path
      d='M4 0.5H36C37.933 0.5 39.5 2.067 39.5 4V36C39.5 37.933 37.933 39.5 36 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4C0.500001 2.067 2.067 0.5 4 0.5Z'
      stroke='#EEF2F6'
    />
    <g clipPath='url(#clip0_17577_24467)'>
      <path
        d='M31.8625 16.7633C31.7451 16.6201 31.5699 16.5365 31.3862 16.5365H29.0504C28.474 15.0162 27.7231 13.5265 26.8695 12.9642C23.9167 11.0217 16.0847 11.0217 13.1319 12.9642C12.2778 13.5271 11.5299 15.0186 10.9504 16.5365H8.61462C8.42904 16.5365 8.25452 16.6201 8.13837 16.7633C8.02161 16.9058 7.97491 17.0945 8.01301 17.2758L8.35898 18.9522C8.41798 19.238 8.66993 19.442 8.9606 19.442H9.65254C8.98456 20.2127 8.66071 21.183 8.65641 22.154C8.65211 23.3535 9.10747 24.4376 9.94014 25.2045C9.94936 25.2125 9.95857 25.218 9.96718 25.226V27.5717C9.96718 28.0799 10.3801 28.4935 10.889 28.4935H13.0435C13.5523 28.4935 13.9652 28.0799 13.9652 27.5717V26.629H26.035V27.5717C26.035 28.0799 26.4479 28.4935 26.9568 28.4935H29.1113C29.6188 28.4935 30.033 28.0799 30.033 27.5717V25.2721C30.9167 24.4628 31.3389 23.3492 31.3444 22.2375C31.3481 21.2334 31.0095 20.2274 30.3022 19.4408H31.0402C31.3321 19.4408 31.5841 19.2368 31.6418 18.9504L31.9884 17.2746C32.0241 17.0945 31.9792 16.9071 31.8625 16.7633ZM14.1441 14.5036C16.4977 12.9544 23.5026 12.9544 25.8549 14.5036C26.3121 14.8035 26.9002 16.016 27.4392 17.5007H12.5611C13.0988 16.0166 13.6869 14.8048 14.1441 14.5036ZM11.3873 22.385C11.3873 21.3833 12.1997 20.5722 13.2008 20.5722C14.2031 20.5722 15.0142 21.3833 15.0142 22.385C15.0142 23.3867 14.2031 24.1985 13.2008 24.1985C12.1997 24.1985 11.3873 23.3867 11.3873 22.385ZM26.8234 24.1985C25.8224 24.1985 25.01 23.3867 25.01 22.385C25.01 21.3833 25.8224 20.5722 26.8234 20.5722C27.8257 20.5722 28.6368 21.3833 28.6368 22.385C28.6368 23.3867 27.8245 24.1985 26.8234 24.1985Z'
        fill='url(#paint0_linear_17577_24467)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_17577_24467'
        x1='20.0002'
        y1='11.5073'
        x2='20.0002'
        y2='28.4935'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <clipPath id='clip0_17577_24467'>
        <rect width='24' height='24' fill='white' transform='translate(8 8)' />
      </clipPath>
    </defs>
  </svg>
);

export const IconCarPlus = ({
  width = 20,
  height = 21,
  color = 'currentColor',
}) => (
  <svg
    width='41'
    height='40'
    viewBox='0 0 41 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.6665 0.5H36.6665C38.5995 0.5 40.1665 2.067 40.1665 4V36C40.1665 37.933 38.5995 39.5 36.6665 39.5H4.6665C2.73351 39.5 1.1665 37.933 1.1665 36V4C1.1665 2.067 2.73351 0.5 4.6665 0.5Z'
      fill='white'
    />
    <path
      d='M4.6665 0.5H36.6665C38.5995 0.5 40.1665 2.067 40.1665 4V36C40.1665 37.933 38.5995 39.5 36.6665 39.5H4.6665C2.73351 39.5 1.1665 37.933 1.1665 36V4C1.1665 2.067 2.73351 0.5 4.6665 0.5Z'
      stroke='#EEF2F6'
    />
    <g clipPath='url(#clip0_17577_24476)'>
      <path
        d='M32.529 16.7633C32.4116 16.6201 32.2364 16.5365 32.0527 16.5365H29.7169C29.1405 15.0162 28.3896 13.5265 27.536 12.9642C24.5832 11.0217 16.7512 11.0217 13.7984 12.9642C12.9443 13.5271 12.1964 15.0186 11.6169 16.5365H9.28113C9.09554 16.5365 8.92102 16.6201 8.80488 16.7633C8.68812 16.9058 8.64141 17.0945 8.67951 17.2758L9.02549 18.9522C9.08448 19.238 9.33643 19.442 9.6271 19.442H10.319C9.65107 20.2127 9.32722 21.183 9.32291 22.154C9.31861 23.3535 9.77397 24.4376 10.6066 25.2045C10.6159 25.2125 10.6251 25.218 10.6337 25.226V27.5717C10.6337 28.0799 11.0466 28.4935 11.5555 28.4935H13.71C14.2188 28.4935 14.6317 28.0799 14.6317 27.5717V26.629H26.7015V27.5717C26.7015 28.0799 27.1144 28.4935 27.6233 28.4935H29.7778C30.2854 28.4935 30.6995 28.0799 30.6995 27.5717V25.2721C31.5832 24.4628 32.0054 23.3492 32.0109 22.2375C32.0146 21.2334 31.676 20.2274 30.9687 19.4408H31.7067C31.9986 19.4408 32.2506 19.2368 32.3083 18.9504L32.6549 17.2746C32.6906 17.0945 32.6457 16.9071 32.529 16.7633ZM14.8106 14.5036C17.1642 12.9544 24.1691 12.9544 26.5214 14.5036C26.9786 14.8035 27.5667 16.016 28.1057 17.5007H13.2276C13.7653 16.0166 14.3534 14.8048 14.8106 14.5036ZM12.0538 22.385C12.0538 21.3833 12.8662 20.5722 13.8673 20.5722C14.8696 20.5722 15.6807 21.3833 15.6807 22.385C15.6807 23.3867 14.8696 24.1985 13.8673 24.1985C12.8662 24.1985 12.0538 23.3867 12.0538 22.385ZM27.4899 24.1985C26.4889 24.1985 25.6765 23.3867 25.6765 22.385C25.6765 21.3833 26.4889 20.5722 27.4899 20.5722C28.4922 20.5722 29.3034 21.3833 29.3034 22.385C29.3034 23.3867 28.491 24.1985 27.4899 24.1985Z'
        fill='url(#paint0_linear_17577_24476)'
      />
    </g>
    <path
      d='M26.6665 16C28.8756 16 30.6665 14.2091 30.6665 12C30.6665 9.79086 28.8756 8 26.6665 8C24.4574 8 22.6665 9.79086 22.6665 12C22.6665 14.2091 24.4574 16 26.6665 16Z'
      fill='url(#paint1_linear_17577_24476)'
    />
    <path
      d='M26.6665 10.4V13.6M25.0665 12H28.2665M30.6665 12C30.6665 14.2091 28.8756 16 26.6665 16C24.4574 16 22.6665 14.2091 22.6665 12C22.6665 9.79086 24.4574 8 26.6665 8C28.8756 8 30.6665 9.79086 30.6665 12Z'
      stroke='white'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_17577_24476'
        x1='20.6667'
        y1='11.5073'
        x2='20.6667'
        y2='28.4935'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_17577_24476'
        x1='26.6665'
        y1='8'
        x2='26.6665'
        y2='16'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <clipPath id='clip0_17577_24476'>
        <rect
          width='24'
          height='24'
          fill='white'
          transform='translate(8.6665 8)'
        />
      </clipPath>
    </defs>
  </svg>
);

export const IconCarQuestion = ({
  width = 20,
  height = 21,
  color = 'currentColor',
}) => (
  <svg
    width='41'
    height='40'
    viewBox='0 0 41 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.3335 0.5H36.3335C38.2665 0.5 39.8335 2.067 39.8335 4V36C39.8335 37.933 38.2665 39.5 36.3335 39.5H4.3335C2.4005 39.5 0.833496 37.933 0.833496 36V4C0.833497 2.067 2.4005 0.5 4.3335 0.5Z'
      fill='white'
    />
    <path
      d='M4.3335 0.5H36.3335C38.2665 0.5 39.8335 2.067 39.8335 4V36C39.8335 37.933 38.2665 39.5 36.3335 39.5H4.3335C2.4005 39.5 0.833496 37.933 0.833496 36V4C0.833497 2.067 2.4005 0.5 4.3335 0.5Z'
      stroke='#EEF2F6'
    />
    <g clipPath='url(#clip0_17577_24486)'>
      <path
        d='M32.1959 16.7633C32.0786 16.6201 31.9034 16.5365 31.7197 16.5365H29.3839C28.8075 15.0162 28.0566 13.5265 27.203 12.9642C24.2502 11.0217 16.4182 11.0217 13.4654 12.9642C12.6113 13.5271 11.8634 15.0186 11.2839 16.5365H8.94812C8.76254 16.5365 8.58801 16.6201 8.47187 16.7633C8.35511 16.9058 8.30841 17.0945 8.34651 17.2758L8.69248 18.9522C8.75147 19.238 9.00343 19.442 9.29409 19.442H9.98604C9.31806 20.2127 8.99421 21.183 8.98991 22.154C8.98561 23.3535 9.44096 24.4376 10.2736 25.2045C10.2829 25.2125 10.2921 25.218 10.3007 25.226V27.5717C10.3007 28.0799 10.7136 28.4935 11.2225 28.4935H13.377C13.8858 28.4935 14.2987 28.0799 14.2987 27.5717V26.629H26.3685V27.5717C26.3685 28.0799 26.7814 28.4935 27.2903 28.4935H29.4448C29.9523 28.4935 30.3665 28.0799 30.3665 27.5717V25.2721C31.2502 24.4628 31.6724 23.3492 31.6779 22.2375C31.6816 21.2334 31.343 20.2274 30.6357 19.4408H31.3737C31.6656 19.4408 31.9176 19.2368 31.9753 18.9504L32.3219 17.2746C32.3576 17.0945 32.3127 16.9071 32.1959 16.7633ZM14.4776 14.5036C16.8312 12.9544 23.836 12.9544 26.1884 14.5036C26.6456 14.8035 27.2337 16.016 27.7726 17.5007H12.8946C13.4323 16.0166 14.0204 14.8048 14.4776 14.5036ZM11.7208 22.385C11.7208 21.3833 12.5332 20.5722 13.5343 20.5722C14.5365 20.5722 15.3477 21.3833 15.3477 22.385C15.3477 23.3867 14.5365 24.1985 13.5343 24.1985C12.5332 24.1985 11.7208 23.3867 11.7208 22.385ZM27.1569 24.1985C26.1559 24.1985 25.3435 23.3867 25.3435 22.385C25.3435 21.3833 26.1559 20.5722 27.1569 20.5722C28.1592 20.5722 28.9703 21.3833 28.9703 22.385C28.9703 23.3867 28.158 24.1985 27.1569 24.1985Z'
        fill='url(#paint0_linear_17577_24486)'
      />
    </g>
    <path
      d='M26.3335 16C28.5426 16 30.3335 14.2091 30.3335 12C30.3335 9.79086 28.5426 8 26.3335 8C24.1244 8 22.3335 9.79086 22.3335 12C22.3335 14.2091 24.1244 16 26.3335 16Z'
      fill='url(#paint1_linear_17577_24486)'
    />
    <path
      d='M25.1695 10.8C25.2635 10.5327 25.4492 10.3072 25.6935 10.1637C25.9378 10.0201 26.2251 9.96758 26.5044 10.0155C26.7837 10.0634 27.037 10.2086 27.2195 10.4254C27.402 10.6422 27.5019 10.9166 27.5015 11.2C27.5015 12 26.3015 12.4 26.3015 12.4'
      fill='url(#paint2_linear_17577_24486)'
    />
    <path
      d='M25.1695 10.8C25.2635 10.5327 25.4492 10.3072 25.6935 10.1637C25.9378 10.0201 26.2251 9.96758 26.5044 10.0155C26.7837 10.0634 27.037 10.2086 27.2195 10.4254C27.402 10.6422 27.5019 10.9166 27.5015 11.2C27.5015 12 26.3015 12.4 26.3015 12.4M26.3335 14H26.3375M30.3335 12C30.3335 14.2091 28.5426 16 26.3335 16C24.1244 16 22.3335 14.2091 22.3335 12C22.3335 9.79086 24.1244 8 26.3335 8C28.5426 8 30.3335 9.79086 30.3335 12Z'
      stroke='white'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_17577_24486'
        x1='20.3337'
        y1='11.5073'
        x2='20.3337'
        y2='28.4935'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_17577_24486'
        x1='26.3335'
        y1='8'
        x2='26.3335'
        y2='16'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_17577_24486'
        x1='26.3335'
        y1='8'
        x2='26.3335'
        y2='16'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <clipPath id='clip0_17577_24486'>
        <rect
          width='24'
          height='24'
          fill='white'
          transform='translate(8.3335 8)'
        />
      </clipPath>
    </defs>
  </svg>
);

export const IconConstruction = ({
  width = 20,
  height = 21,
  color = 'currentColor',
}) => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4 0.5H36C37.933 0.5 39.5 2.067 39.5 4V36C39.5 37.933 37.933 39.5 36 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4C0.500001 2.067 2.067 0.5 4 0.5Z'
      fill='white'
    />
    <path
      d='M4 0.5H36C37.933 0.5 39.5 2.067 39.5 4V36C39.5 37.933 37.933 39.5 36 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4C0.500001 2.067 2.067 0.5 4 0.5Z'
      stroke='#EEF2F6'
    />
    <g clipPath='url(#clip0_17577_24497)'>
      <path
        d='M28.9999 25.9999H11C9.34377 25.9999 8 27.3439 8 28.9999C8 30.6563 9.34377 32.0001 11 32.0001H28.9999C30.6563 32.0001 32.0001 30.6563 32.0001 28.9999C32.0001 27.3439 30.6563 25.9999 28.9999 25.9999ZM11 30.0001C10.4472 30.0001 10.0002 29.5531 10.0002 28.9999C10.0002 28.4474 10.4472 28.0004 11 28.0004C11.5529 28.0004 11.9999 28.4474 11.9999 28.9999C11.9999 29.5531 11.5529 30.0001 11 30.0001ZM15.5 30.0001C14.947 30.0001 14.5 29.5531 14.5 28.9999C14.5 28.4474 14.947 28.0004 15.5 28.0004C16.053 28.0004 16.5 28.4474 16.5 28.9999C16.5 29.5531 16.053 30.0001 15.5 30.0001ZM20 30.0001C19.4471 30.0001 19.0001 29.5531 19.0001 28.9999C19.0001 28.4474 19.4471 28.0004 20 28.0004C20.5528 28.0004 20.9998 28.4474 20.9998 28.9999C20.9998 29.5531 20.5528 30.0001 20 30.0001ZM24.5001 30.0001C23.9471 30.0001 23.5001 29.5531 23.5001 28.9999C23.5001 28.4474 23.9471 28.0004 24.5001 28.0004C25.0528 28.0004 25.4998 28.4474 25.4998 28.9999C25.4998 29.5531 25.0528 30.0001 24.5001 30.0001ZM28.9999 30.0001C28.4472 30.0001 28.0002 29.5531 28.0002 28.9999C28.0002 28.4474 28.4472 28.0004 28.9999 28.0004C29.5529 28.0004 29.9999 28.4474 29.9999 28.9999C29.9999 29.5531 29.5529 30.0001 28.9999 30.0001Z'
        fill='url(#paint0_linear_17577_24497)'
      />
      <path
        d='M20.6661 14.9999L19.0001 9.99976H11V14.9999H20.6661Z'
        fill='url(#paint1_linear_17577_24497)'
      />
      <path
        d='M31 18.277V8H28.9998L22.5994 20.8004L21.3327 17.0001H17V24.0002H26.9998V21.9998H24.2361L28.9998 12.4724V18.277C28.4045 18.6226 28.0001 19.2614 28.0001 19.9996C28.0001 21.103 28.8943 21.9998 29.9998 21.9998C31.1055 21.9998 32 21.1035 32 20C32 19.2617 31.5956 18.6231 31 18.277Z'
        fill='url(#paint2_linear_17577_24497)'
      />
      <path
        d='M14.9999 17.0001H11V21.9998H8V24.0002H14.9999V17.0001Z'
        fill='url(#paint3_linear_17577_24497)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_17577_24497'
        x1='20'
        y1='25.9999'
        x2='20'
        y2='32.0001'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_17577_24497'
        x1='15.8331'
        y1='9.99976'
        x2='15.8331'
        y2='14.9999'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_17577_24497'
        x1='24.5'
        y1='8'
        x2='24.5'
        y2='24.0002'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_17577_24497'
        x1='11.4999'
        y1='17.0001'
        x2='11.4999'
        y2='24.0002'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <clipPath id='clip0_17577_24497'>
        <rect width='24' height='24' fill='white' transform='translate(8 8)' />
      </clipPath>
    </defs>
  </svg>
);

export const IconTravel = ({
  width = 20,
  height = 21,
  color = 'currentColor',
}) => (
  <svg
    width='41'
    height='40'
    viewBox='0 0 41 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.6665 0.5H36.6665C38.5995 0.5 40.1665 2.067 40.1665 4V36C40.1665 37.933 38.5995 39.5 36.6665 39.5H4.6665C2.73351 39.5 1.1665 37.933 1.1665 36V4C1.1665 2.067 2.73351 0.5 4.6665 0.5Z'
      fill='white'
    />
    <path
      d='M4.6665 0.5H36.6665C38.5995 0.5 40.1665 2.067 40.1665 4V36C40.1665 37.933 38.5995 39.5 36.6665 39.5H4.6665C2.73351 39.5 1.1665 37.933 1.1665 36V4C1.1665 2.067 2.73351 0.5 4.6665 0.5Z'
      stroke='#EEF2F6'
    />
    <g clipPath='url(#clip0_17577_24507)'>
      <path
        d='M29.8358 11.0612C28.678 9.86924 27.2451 8.97365 25.7153 8.45807C25.2527 8.85754 24.9834 9.4341 24.9834 10.0537C24.9834 10.986 25.5826 11.7983 26.4744 12.0749C26.6828 12.1396 26.8494 12.2969 26.9253 12.5008C27.0012 12.7048 26.978 12.9323 26.8624 13.1169C26.5439 13.6254 26.3755 14.2119 26.3755 14.8131C26.3755 16.5825 27.8194 18.022 29.5941 18.022H32.6656C32.6659 17.9895 32.6666 17.9571 32.6667 17.9245L32.6667 17.902C32.6615 15.3648 31.6562 12.9353 29.8358 11.0612Z'
        fill='url(#paint0_linear_17577_24507)'
      />
      <path
        d='M16.7788 20.0515L17.8191 19.0106C17.8605 18.9693 17.9029 18.9281 17.9451 18.8884C18.5594 18.3103 19.2823 17.8819 20.0645 17.6219C19.8306 16.4495 18.8341 15.5928 17.6051 15.5928H12.9588C12.7586 16.3901 12.6562 17.2118 12.6548 18.0436L12.6549 18.0735L16.7788 20.0515Z'
        fill='url(#paint1_linear_17577_24507)'
      />
      <path
        d='M19.0487 23.9194C18.9747 23.7659 19.0058 23.5824 19.1263 23.4618L20.6349 21.9525C21.4321 21.1548 21.8841 20.0792 21.8998 18.9567C21.9014 18.8404 21.8039 18.7456 21.6878 18.7506C20.6865 18.7943 19.6553 19.216 18.9158 19.9209L17.2717 21.5629C17.1515 21.6832 16.9685 21.7145 16.8152 21.641L11.123 18.9107C10.9697 18.8372 10.7867 18.8685 10.6664 18.9888L9.5494 20.1064C9.37151 20.2844 9.39963 20.5805 9.60781 20.7218L14.2742 23.8883C14.4824 24.0296 14.5105 24.3257 14.3326 24.5036L12.6013 26.2359C12.4837 26.3536 12.3056 26.3863 12.1538 26.3181L10.2613 25.4679C10.1119 25.4007 9.93677 25.4313 9.81893 25.5451L8.78909 26.539C8.58982 26.7313 8.64087 27.0631 8.8887 27.1865L11.3752 28.4249L11.3762 28.423C11.4358 28.6344 11.5484 28.8339 11.7146 29.0003C11.8547 29.1405 12.0184 29.2427 12.1929 29.3071C12.2898 29.3428 12.3697 29.4136 12.4153 29.5063L13.5331 31.7762C13.6544 32.0226 13.9818 32.0767 14.1759 31.8825L15.1387 30.9192C15.2554 30.8024 15.2886 30.626 15.2224 30.4748L14.3861 28.5651C14.3199 28.4138 14.3531 28.2374 14.4698 28.1207L16.2158 26.3738C16.3911 26.1984 16.682 26.2227 16.8257 26.4249L20.0538 30.9665C20.1975 31.1687 20.4883 31.193 20.6636 31.0176L21.68 30.0007C21.8005 29.8802 21.8316 29.6966 21.7577 29.5431L19.0487 23.9194Z'
        fill='url(#paint2_linear_17577_24507)'
      />
      <path
        d='M29.6479 19.5824C27.081 19.5824 24.9926 17.4929 24.9926 14.9245C24.9926 14.3224 25.1086 13.7302 25.3319 13.1782C24.2661 12.5501 23.5917 11.4019 23.5917 10.1182C23.5917 9.3919 23.8102 8.70068 24.2045 8.1214C23.926 8.07579 23.6462 8.04242 23.3662 8.02278C20.7761 7.84104 18.6894 8.78168 17.395 9.60275C15.7484 10.6471 14.3683 12.1526 13.6086 13.733C13.539 13.8778 13.4736 14.0254 13.4126 14.1752H17.6049C18.6667 14.1752 19.6586 14.5909 20.3976 15.3455C20.9404 15.8998 21.301 16.5915 21.4517 17.3451C21.5921 17.3348 21.7334 17.3295 21.8754 17.3295H21.8975C22.6609 17.3295 23.2871 17.9347 23.3134 18.6981C23.368 20.2824 22.7568 21.8338 21.6365 22.9547L20.6379 23.9539L22.6376 28.1048C22.6448 28.1045 22.6518 28.1037 22.6591 28.1037C22.6633 28.1039 22.6668 28.1037 22.6705 28.1037C24.6015 28.1037 26.5285 27.4944 28.2445 26.3412C29.7999 25.2958 31.0575 23.8858 31.7857 22.371C31.9754 21.9764 32.1341 21.5614 32.2572 21.1375L32.2627 21.1196C32.4232 20.6174 32.5433 20.1037 32.623 19.5823H29.6479V19.5824Z'
        fill='url(#paint3_linear_17577_24507)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_17577_24507'
        x1='28.8251'
        y1='8.45807'
        x2='28.8251'
        y2='18.022'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_17577_24507'
        x1='16.3596'
        y1='15.5928'
        x2='16.3596'
        y2='20.0515'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_17577_24507'
        x1='15.2832'
        y1='18.7504'
        x2='15.2832'
        y2='32'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_17577_24507'
        x1='23.0178'
        y1='8'
        x2='23.0178'
        y2='28.1048'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <clipPath id='clip0_17577_24507'>
        <rect
          width='24'
          height='24'
          fill='white'
          transform='translate(8.6665 8)'
        />
      </clipPath>
    </defs>
  </svg>
);

export const IconHome = ({
  width = 20,
  height = 21,
  color = 'currentColor',
}) => (
  <svg
    width='41'
    height='40'
    viewBox='0 0 41 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.3335 0.5H36.3335C38.2665 0.5 39.8335 2.067 39.8335 4V36C39.8335 37.933 38.2665 39.5 36.3335 39.5H4.3335C2.4005 39.5 0.833496 37.933 0.833496 36V4C0.833497 2.067 2.4005 0.5 4.3335 0.5Z'
      fill='white'
    />
    <path
      d='M4.3335 0.5H36.3335C38.2665 0.5 39.8335 2.067 39.8335 4V36C39.8335 37.933 38.2665 39.5 36.3335 39.5H4.3335C2.4005 39.5 0.833496 37.933 0.833496 36V4C0.833497 2.067 2.4005 0.5 4.3335 0.5Z'
      stroke='#EEF2F6'
    />
    <g clipPath='url(#clip0_17577_24520)'>
      <path
        d='M29.1968 14.1928C30.9033 14.1928 32.2867 12.8065 32.2867 11.0964C32.2867 9.38632 30.9033 8 29.1968 8C27.4903 8 26.1069 9.38632 26.1069 11.0964C26.1069 12.8065 27.4903 14.1928 29.1968 14.1928Z'
        fill='url(#paint0_linear_17577_24520)'
      />
      <path
        d='M25.1802 25.3607H27.1679V27.3526H25.1802V25.3607Z'
        fill='url(#paint1_linear_17577_24520)'
      />
      <path
        d='M21.5622 14.527C21.9477 14.1843 22.4439 13.9955 22.9593 13.9955C23.4746 13.9955 23.9708 14.1843 24.3563 14.527L24.9103 15.0195V13.2599C24.9103 10.3635 22.5588 8.00708 19.6684 8.00708C17.1366 8.00708 15.0183 9.81519 14.5317 12.2105C15.3276 13.4219 16.7224 15.7898 17.319 18.299L21.5622 14.527Z'
        fill='url(#paint2_linear_17577_24520)'
      />
      <path
        d='M31.6317 30.5846H30.6625V23.8934L31.1192 24.2994C31.2528 24.4182 31.4191 24.4766 31.5847 24.4765C31.7784 24.4765 31.9712 24.3966 32.1099 24.2399C32.3671 23.9494 32.3406 23.5049 32.0506 23.2472L29.9934 21.4185V17.774C29.9934 17.3856 29.6792 17.0707 29.2916 17.0707C28.9041 17.0707 28.5899 17.3856 28.5899 17.774V20.1708L23.4246 15.5791C23.1589 15.3429 22.759 15.3429 22.4933 15.5791L13.8673 23.2472C13.5774 23.5049 13.5509 23.9494 13.808 24.2399C14.0652 24.5305 14.5088 24.557 14.7987 24.2993L15.2554 23.8933V30.5845H12.9906V27.5165C13.2904 27.4247 13.5789 27.2739 13.852 27.0673V25.827C13.4325 25.7283 13.049 25.5018 12.7582 25.1733C11.9879 24.3031 12.0676 22.9671 12.9359 22.1951L16.1034 19.3794C15.5702 15.971 12.9759 12.4172 12.8533 12.251C12.721 12.0715 12.5116 11.9656 12.2889 11.9656C12.0662 11.9656 11.8568 12.0715 11.7245 12.251C11.5878 12.4363 8.37864 16.8317 8.37864 20.5424C8.37864 22.3535 8.73906 24.0673 9.39353 25.3679C9.97084 26.5153 10.7332 27.2554 11.5871 27.5166V30.5846H9.03526C8.6477 30.5846 8.3335 30.8994 8.3335 31.2878C8.3335 31.6762 8.6477 31.991 9.03526 32H30.6625H31.6318C32.0193 31.991 32.3335 31.6762 32.3335 31.2878C32.3335 30.8994 32.0193 30.5846 31.6317 30.5846ZM23.7767 24.6575C23.7767 24.2692 24.0909 23.9543 24.4784 23.9543H27.8697C28.2572 23.9543 28.5714 24.2692 28.5714 24.6575V28.0559C28.5714 28.4443 28.2572 28.7591 27.8697 28.7591H24.4784C24.0909 28.7591 23.7767 28.4443 23.7767 28.0559V24.6575ZM19.9339 30.5846V25.3607H18.5304V30.5846H17.1269V24.6575C17.1269 24.2691 17.4411 23.9543 17.8286 23.9543H20.6357C21.0232 23.9543 21.3374 24.2692 21.3374 24.6575V30.5846H19.9339Z'
        fill='url(#paint3_linear_17577_24520)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_17577_24520'
        x1='29.1968'
        y1='8'
        x2='29.1968'
        y2='14.1928'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_17577_24520'
        x1='26.174'
        y1='25.3607'
        x2='26.174'
        y2='27.3526'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_17577_24520'
        x1='19.721'
        y1='8.00708'
        x2='19.721'
        y2='18.299'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_17577_24520'
        x1='20.3335'
        y1='11.9656'
        x2='20.3335'
        y2='32'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <clipPath id='clip0_17577_24520'>
        <rect
          width='24'
          height='24'
          fill='white'
          transform='translate(8.3335 8)'
        />
      </clipPath>
    </defs>
  </svg>
);

const HEALTH_ICON_VIEWBOX_FULL = '0 0 40 40';
/** Tighter crop when the white square background is hidden (e.g. stepper header circle). */
const HEALTH_ICON_VIEWBOX_MARK = '8 7 24 26';

export const IconHealth = ({
  width = 40,
  height = 40,
  color = 'currentColor',
  showBackground = true,
}) => (
  <svg
    width={width}
    height={height}
    viewBox={showBackground ? HEALTH_ICON_VIEWBOX_FULL : HEALTH_ICON_VIEWBOX_MARK}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    {showBackground ? (
      <>
        <path
          d='M4 0.5H36C37.933 0.5 39.5 2.067 39.5 4V36C39.5 37.933 37.933 39.5 36 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4C0.500001 2.067 2.067 0.5 4 0.5Z'
          fill='white'
        />
        <path
          d='M4 0.5H36C37.933 0.5 39.5 2.067 39.5 4V36C39.5 37.933 37.933 39.5 36 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4C0.500001 2.067 2.067 0.5 4 0.5Z'
          stroke='#EEF2F6'
        />
      </>
    ) : null}
    <path
      d='M21.4034 19.0664H23.6653V20.4664H21.4034C21.0149 20.4664 20.7004 20.7814 20.7004 21.1695V23.4318H19.3004V21.1695C19.3004 20.7814 18.9859 20.4664 18.5973 20.4664H16.335V19.0664H18.5973C18.9859 19.0664 19.3004 18.7519 19.3004 18.3634V16.101H20.7004V18.3634C20.7004 18.7519 21.0149 19.0664 21.4034 19.0664Z'
      fill='url(#paint0_linear_17577_24531)'
    />
    <path
      d='M30.1696 14.5093L30.1691 14.4864C30.1579 13.8883 30.1471 13.3231 30.1471 12.7794C30.1471 11.9554 29.4769 11.2857 28.6534 11.2857C25.4663 11.2857 23.0474 10.3769 21.0409 8.42569C20.4569 7.8581 19.542 7.8581 18.958 8.42569C16.952 10.3769 14.5331 11.2857 11.3465 11.2857C10.523 11.2857 9.85273 11.9554 9.85273 12.7794C9.85273 13.3343 9.84195 13.9052 9.83024 14.5098C9.77634 17.3313 9.70931 20.8428 10.8876 24.0303C11.5358 25.7832 12.5168 27.306 13.8038 28.5574C15.2699 29.9827 17.1896 31.1132 19.5101 31.9175C19.6681 31.9723 19.8326 32 19.9995 32C20.1663 32 20.3313 31.9723 20.4888 31.9175C22.8093 31.1132 24.7295 29.9827 26.1956 28.5574C27.4826 27.306 28.4636 25.7828 29.1118 24.0303C30.2905 20.8423 30.2235 17.3308 30.1696 14.5093ZM25.0712 21.1694C25.0712 21.5575 24.7567 21.8724 24.3681 21.8724H22.1062V24.1348C22.1062 24.5229 21.7913 24.8378 21.4032 24.8378H18.5971C18.209 24.8378 17.8941 24.5229 17.8941 24.1348V21.8724H15.6317C15.2432 21.8724 14.9287 21.5575 14.9287 21.1694V18.3633C14.9287 17.9752 15.2432 17.6603 15.6317 17.6603H17.8941V15.3979C17.8941 15.0098 18.209 14.6949 18.5971 14.6949H21.4032C21.7913 14.6949 22.1062 15.0098 22.1062 15.3979V17.6603H24.3681C24.7567 17.6603 25.0712 17.9752 25.0712 18.3633V21.1694Z'
      fill='url(#paint1_linear_17577_24531)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_17577_24531'
        x1='20.0001'
        y1='16.101'
        x2='20.0001'
        y2='23.4318'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_17577_24531'
        x1='19.9999'
        y1='8'
        x2='19.9999'
        y2='32'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
    </defs>
  </svg>
);

export const IconAccident = ({
  width = 20,
  height = 21,
  color = 'currentColor',
}) => (
  <svg
    width='41'
    height='40'
    viewBox='0 0 41 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='20.6665' cy='20' r='19.5' fill='white' />
    <circle cx='20.6665' cy='20' r='19.5' stroke='#EEF2F6' />
    <g clipPath='url(#clip0_17577_24539)'>
      <path
        d='M20.6764 15.466C22.738 15.466 24.4094 13.7947 24.4094 11.733C24.4094 9.67132 22.738 8 20.6764 8C18.6147 8 16.9434 9.67132 16.9434 11.733C16.9434 13.7947 18.6147 15.466 20.6764 15.466Z'
        fill='url(#paint0_linear_17577_24539)'
      />
      <path
        d='M16.0861 22.7801V24.7005H18.4082L16.7916 17.6362C13.9747 18.3417 12.0298 20.0563 12.0298 23.4268V27.6154C12.0298 27.9779 12.3139 28.2621 12.6764 28.2621H19.2068L18.614 25.6509H14.8075C14.9839 24.5095 15.3464 23.7305 16.0861 22.7801Z'
        fill='url(#paint1_linear_17577_24539)'
      />
      <path
        d='M20.2208 28.2817H21.3426C22.0677 28.2817 22.6556 27.6889 22.6556 26.9687C22.6556 26.2486 22.0628 25.6558 21.3426 25.6558H19.6084L20.2208 28.2817Z'
        fill='url(#paint2_linear_17577_24539)'
      />
      <path
        d='M18.6189 25.6706H19.6084L19.4027 24.7006H18.4082L18.6189 25.6706Z'
        fill='url(#paint3_linear_17577_24539)'
      />
      <path
        d='M20.6763 17.215C19.6475 17.215 18.6579 17.2933 17.7418 17.4452L19.4025 24.7006H21.3425C22.6016 24.7006 23.6107 25.7294 23.6107 26.9688C23.6107 28.2278 22.582 29.237 21.3425 29.237H16.0859V32H25.2666V22.7802C26.4472 24.3234 26.6579 29.0655 26.6775 31.9951H29.3033V23.4268C29.3033 18.6651 25.4381 17.215 20.6763 17.215Z'
        fill='url(#paint4_linear_17577_24539)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_17577_24539'
        x1='20.6764'
        y1='8'
        x2='20.6764'
        y2='15.466'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_17577_24539'
        x1='15.6183'
        y1='17.6362'
        x2='15.6183'
        y2='28.2621'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_17577_24539'
        x1='21.132'
        y1='25.6558'
        x2='21.132'
        y2='28.2817'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_17577_24539'
        x1='19.0083'
        y1='24.7006'
        x2='19.0083'
        y2='25.6706'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_17577_24539'
        x1='22.6946'
        y1='17.215'
        x2='22.6946'
        y2='32'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <clipPath id='clip0_17577_24539'>
        <rect
          width='24'
          height='24'
          fill='white'
          transform='translate(8.6665 8)'
        />
      </clipPath>
    </defs>
  </svg>
);

export const IconProfession = ({
  width = 20,
  height = 21,
  color = 'currentColor',
}) => (
  <svg
    width='41'
    height='40'
    viewBox='0 0 41 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.3335 0.5H36.3335C38.2665 0.5 39.8335 2.067 39.8335 4V36C39.8335 37.933 38.2665 39.5 36.3335 39.5H4.3335C2.4005 39.5 0.833496 37.933 0.833496 36V4C0.833497 2.067 2.4005 0.5 4.3335 0.5Z'
      fill='white'
    />
    <path
      d='M4.3335 0.5H36.3335C38.2665 0.5 39.8335 2.067 39.8335 4V36C39.8335 37.933 38.2665 39.5 36.3335 39.5H4.3335C2.4005 39.5 0.833496 37.933 0.833496 36V4C0.833497 2.067 2.4005 0.5 4.3335 0.5Z'
      stroke='#EEF2F6'
    />
    <path
      d='M24.0835 11.75V12.5H22.5835V11.75C22.5835 11.3375 22.246 11 21.8335 11H18.8335C18.421 11 18.0835 11.3375 18.0835 11.75V12.5H16.5835V11.75C16.5835 10.5125 17.596 9.5 18.8335 9.5H21.8335C23.071 9.5 24.0835 10.5125 24.0835 11.75ZM29.3335 22.25H22.5835C22.5835 23.4905 21.574 24.5 20.3335 24.5C19.093 24.5 18.0835 23.4905 18.0835 22.25H11.3335C10.486 22.25 9.712 21.9567 9.0835 21.4813V28.25C9.0835 29.4905 10.093 30.5 11.3335 30.5H29.3335C30.574 30.5 31.5835 29.4905 31.5835 28.25V21.4813C30.955 21.9567 30.181 22.25 29.3335 22.25ZM11.3335 20.75H18.0835V19.25C18.0835 18.8352 18.4195 18.5 18.8335 18.5H21.8335C22.2475 18.5 22.5835 18.8352 22.5835 19.25V20.75H29.3335C30.574 20.75 31.5835 19.7405 31.5835 18.5V16.25C31.5835 15.0095 30.574 14 29.3335 14H11.3335C10.093 14 9.0835 15.0095 9.0835 16.25V18.5C9.0835 19.7405 10.093 20.75 11.3335 20.75ZM20.3335 23C20.7467 23 21.0835 22.664 21.0835 22.25V20H19.5835V22.25C19.5835 22.664 19.9202 23 20.3335 23Z'
      fill='url(#paint0_linear_17577_24553)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_17577_24553'
        x1='20.3335'
        y1='9.5'
        x2='20.3335'
        y2='30.5'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
    </defs>
  </svg>
);

export const IconBike = ({
  width = 20,
  height = 21,
  color = 'currentColor',
}) => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4 0.5H36C37.933 0.5 39.5 2.067 39.5 4V36C39.5 37.933 37.933 39.5 36 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4C0.500001 2.067 2.067 0.5 4 0.5Z'
      fill='white'
    />
    <path
      d='M4 0.5H36C37.933 0.5 39.5 2.067 39.5 4V36C39.5 37.933 37.933 39.5 36 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4C0.500001 2.067 2.067 0.5 4 0.5Z'
      stroke='#EEF2F6'
    />
    <path
      d='M19.1701 22.7461H17.7979V21.8477H19.1701V22.7461Z'
      fill='url(#paint0_linear_17577_24562)'
    />
    <path
      d='M16.7218 14.61L19.9167 21.4292L19.106 21.8082L15.9111 14.9891L16.7218 14.61Z'
      fill='url(#paint1_linear_17577_24562)'
    />
    <path
      d='M13.124 17.0799C15.9537 17.0799 18.2479 19.3741 18.2479 22.2039C18.2479 25.0336 15.9537 27.3278 13.124 27.3278C10.2942 27.3278 8 25.0336 8 22.2039C8 19.3741 10.2942 17.0799 13.124 17.0799ZM15.6643 19.1207C14.7724 18.3851 13.6077 18.0735 12.4649 18.2632L13.2603 21.2314C13.341 21.2426 13.4186 21.2637 13.4918 21.2932L15.6643 19.1207ZM16.207 19.6635L14.0346 21.836C14.0642 21.9092 14.0852 21.9868 14.0964 22.0676L17.0646 22.8629C17.096 22.6739 17.1141 22.4804 17.1179 22.2834C17.1361 21.3251 16.8172 20.4031 16.207 19.6635ZM16.8666 23.6036L13.8979 22.8081C13.8485 22.8713 13.7914 22.9284 13.7282 22.9778L14.5237 25.9465C15.6039 25.5423 16.4624 24.6839 16.8666 23.6036ZM13.783 26.1445L12.9877 23.1763C12.9069 23.1651 12.8293 23.1441 12.7561 23.1145L10.5836 25.287C11.2741 25.8565 12.1591 26.1986 13.124 26.1986C13.3484 26.1986 13.5685 26.1801 13.783 26.1445ZM12.1515 22.3402L9.1833 21.5449C9.1477 21.7592 9.12921 21.9794 9.12921 22.2039C9.12921 23.1688 9.47131 24.0538 10.0408 24.7441L12.2133 22.5717C12.1837 22.4985 12.1627 22.4209 12.1515 22.3402ZM12.5197 21.4299L11.7242 18.4612C10.644 18.8654 9.7855 19.7239 9.38134 20.8041L12.35 21.5996C12.3994 21.5364 12.4564 21.4794 12.5197 21.4299Z'
      fill='url(#paint2_linear_17577_24562)'
    />
    <path
      d='M26.8764 17.0799C29.7061 17.0799 32.0003 19.3741 32.0003 22.2039C32.0003 25.0336 29.7061 27.3278 26.8764 27.3278C24.0466 27.3278 21.7524 25.0336 21.7524 22.2039C21.7524 19.3741 24.0466 17.0799 26.8764 17.0799ZM29.4167 19.1207C28.5233 18.3838 27.3564 18.0741 26.2174 18.2632L27.0127 21.2314C27.0934 21.2426 27.171 21.2637 27.2442 21.2932L29.4167 19.1207ZM29.9595 19.6635L27.787 21.836C27.8166 21.9092 27.8376 21.9868 27.8488 22.0676L30.817 22.8629C30.8484 22.6739 30.8665 22.4804 30.8703 22.2834C30.8884 21.3251 30.5695 20.4031 29.9595 19.6635ZM30.619 23.6036L27.6503 22.8081C27.6009 22.8713 27.5438 22.9284 27.4806 22.9778L28.2761 25.9465C29.3563 25.5423 30.2148 24.6839 30.619 23.6036ZM27.5354 26.1445L26.74 23.1763C26.6593 23.1651 26.5818 23.1441 26.5086 23.1145L24.3361 25.287C25.0265 25.8565 25.9115 26.1986 26.8764 26.1986C27.1008 26.1986 27.321 26.1801 27.5354 26.1445ZM25.9039 22.3402L22.9357 21.5449C22.9001 21.7592 22.8817 21.9794 22.8817 22.2039C22.8817 23.1688 23.2237 24.0538 23.7932 24.7441L25.9657 22.5717C25.9361 22.4985 25.9151 22.4209 25.9039 22.3402ZM26.2721 21.4299L25.4766 18.4612C24.3964 18.8654 23.5379 19.7239 23.1337 20.8041L26.1024 21.5996C26.1519 21.5364 26.2089 21.4794 26.2721 21.4299Z'
      fill='url(#paint3_linear_17577_24562)'
    />
    <path
      d='M25.2014 15.0487L20.2143 21.9294L19.4668 21.4311L24.4539 14.5504L25.2014 15.0487Z'
      fill='url(#paint4_linear_17577_24562)'
    />
    <path
      d='M25.1721 17.8197L24.4832 15.2487H16.6L15.2834 18.059L14.4727 17.6799L16.0327 14.3503H25.1714L26.0389 17.588L25.1721 17.8197Z'
      fill='url(#paint5_linear_17577_24562)'
    />
    <path
      d='M19.8294 20.9902C20.4996 20.9902 21.0431 21.5337 21.0431 22.2039C21.0431 22.8741 20.4996 23.4176 19.8294 23.4176C19.1592 23.4176 18.6157 22.8741 18.6157 22.2039C18.6157 21.5337 19.1592 20.9902 19.8294 20.9902ZM19.8294 21.8886C19.6552 21.8886 19.5141 22.0297 19.5141 22.2039C19.5141 22.3781 19.6552 22.5191 19.8294 22.5191C20.0036 22.5191 20.1447 22.3781 20.1447 22.2039C20.1447 22.0297 20.0036 21.8886 19.8294 21.8886Z'
      fill='url(#paint6_linear_17577_24562)'
    />
    <path
      d='M15.911 14.989L15.1548 13.375L15.9654 12.996L16.7217 14.61L15.911 14.989Z'
      fill='url(#paint7_linear_17577_24562)'
    />
    <path
      d='M27.1847 13.6347C27.4327 13.6347 27.6339 13.4336 27.6339 13.1855C27.6339 12.9374 27.4327 12.7363 27.1847 12.7363H25.5837C25.3893 12.7363 25.2237 12.8598 25.1611 13.0326L24.4221 14.61C24.3175 14.8339 24.4141 15.1002 24.638 15.2049C24.8618 15.3095 25.1282 15.2129 25.2328 14.989L25.8673 13.6347H27.1847Z'
      fill='url(#paint8_linear_17577_24562)'
    />
    <path
      d='M14.4875 12.6721C14.204 12.6721 13.9741 12.902 13.9741 13.1855C13.9741 13.469 14.204 13.6989 14.4875 13.6989H16.6331C16.9166 13.6989 17.1465 13.469 17.1465 13.1855C17.1465 12.902 16.9166 12.6721 16.6331 12.6721H14.4875Z'
      fill='url(#paint9_linear_17577_24562)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_17577_24562'
        x1='18.484'
        y1='21.8477'
        x2='18.484'
        y2='22.7461'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_17577_24562'
        x1='17.9139'
        y1='14.61'
        x2='17.9139'
        y2='21.8082'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_17577_24562'
        x1='13.1239'
        y1='17.0799'
        x2='13.1239'
        y2='27.3278'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_17577_24562'
        x1='26.8764'
        y1='17.0799'
        x2='26.8764'
        y2='27.3278'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_17577_24562'
        x1='22.3341'
        y1='14.5504'
        x2='22.3341'
        y2='21.9294'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_17577_24562'
        x1='20.2558'
        y1='14.3503'
        x2='20.2558'
        y2='18.059'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint6_linear_17577_24562'
        x1='19.8294'
        y1='20.9902'
        x2='19.8294'
        y2='23.4176'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint7_linear_17577_24562'
        x1='15.9382'
        y1='12.996'
        x2='15.9382'
        y2='14.989'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint8_linear_17577_24562'
        x1='26.0069'
        y1='12.7363'
        x2='26.0069'
        y2='15.2471'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint9_linear_17577_24562'
        x1='15.5603'
        y1='12.6721'
        x2='15.5603'
        y2='13.6989'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
    </defs>
  </svg>
);

export const IconScooter = ({
  width = 40,
  height = 40,
  color = 'currentColor',
}) => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4 0.5H36C37.933 0.5 39.5 2.067 39.5 4V36C39.5 37.933 37.933 39.5 36 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4C0.500001 2.067 2.067 0.5 4 0.5Z'
      fill='white'
    />
    <path
      d='M4 0.5H36C37.933 0.5 39.5 2.067 39.5 4V36C39.5 37.933 37.933 39.5 36 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4C0.500001 2.067 2.067 0.5 4 0.5Z'
      stroke='#EEF2F6'
    />
    <g
      transform='translate(8 8)'
      stroke='url(#paint0_linear_escooter_cat)'
      strokeWidth='2.15'
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='none'
    >
      <circle cx='5.1' cy='18.55' r='2.7' />
      <circle cx='18.9' cy='18.55' r='2.7' />
      <path d='M5.1 18.55H14.4L17.7 15.25' />
      <path d='M18.9 18.55L14.35 5.35' />
      <path d='M14.35 5.35H9.85' />
      <path
        d='M11.55 7.55 9.55 11.15h1.35L9.45 14.35l3.55-4.05h-1.35L13.15 7.55h-1.6Z'
        fill='url(#paint0_linear_escooter_cat)'
        stroke='none'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_escooter_cat'
        x1='20'
        y1='12.5'
        x2='20'
        y2='28.5'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
    </defs>
  </svg>
);

export const IconTractor = ({
  width = 20,
  height = 21,
  color = 'currentColor',
}) => (
  <svg
    width='41'
    height='40'
    viewBox='0 0 41 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.6665 0.5H36.6665C38.5995 0.5 40.1665 2.067 40.1665 4V36C40.1665 37.933 38.5995 39.5 36.6665 39.5H4.6665C2.73351 39.5 1.1665 37.933 1.1665 36V4C1.1665 2.067 2.73351 0.5 4.6665 0.5Z'
      fill='white'
    />
    <path
      d='M4.6665 0.5H36.6665C38.5995 0.5 40.1665 2.067 40.1665 4V36C40.1665 37.933 38.5995 39.5 36.6665 39.5H4.6665C2.73351 39.5 1.1665 37.933 1.1665 36V4C1.1665 2.067 2.73351 0.5 4.6665 0.5Z'
      stroke='#EEF2F6'
    />
    <g clipPath='url(#clip0_17577_24580)'>
      <path
        d='M14.6981 15.1134C14.203 15.2334 13.8994 15.7335 14.0193 16.2286L14.425 17.8795C15.1217 17.9433 15.7953 18.1015 16.4384 18.349L15.8132 15.7871C15.6939 15.3035 15.2079 14.986 14.6981 15.1134Z'
        fill='url(#paint0_linear_17577_24580)'
      />
      <path
        d='M21.5032 15.8305C21.3526 15.685 21.1127 15.685 20.9673 15.8305C20.8933 15.907 19.7348 17.0655 19.6276 17.1727C19.4822 17.3232 19.4822 17.5554 19.6276 17.706C19.791 17.8591 20.0232 17.8464 20.1609 17.706L20.5666 17.3029L21.9752 18.7089L22.4906 18.1654L21.0974 16.7721L21.5031 16.3664C21.6486 16.2158 21.6486 15.981 21.5032 15.8305Z'
        fill='url(#paint1_linear_17577_24580)'
      />
      <path
        d='M26.7268 15.7794H26.7982V17.5478H27.8674V15.7794H27.9465C28.2094 15.7794 28.4186 15.5651 28.4186 15.3074C28.4186 15.0445 28.2094 14.8276 27.9465 14.8276H26.7268C26.464 14.8276 26.2471 15.0445 26.2471 15.3074C26.2471 15.5651 26.464 15.7794 26.7268 15.7794Z'
        fill='url(#paint2_linear_17577_24580)'
      />
      <path
        d='M31.0569 18.0581H23.7258C23.4554 18.0581 23.1951 18.1678 23.0088 18.3643L20.1738 21.3345C21.0241 22.6325 21.4573 24.1072 21.4573 25.6112V26.3359H25.3844C25.7825 24.7027 27.2599 23.4856 29.0155 23.4856C29.8397 23.4856 30.6001 23.7535 31.2176 24.2077L32.5751 20.1709C32.9222 19.1323 32.1516 18.0581 31.0569 18.0581Z'
        fill='url(#paint3_linear_17577_24580)'
      />
      <path
        d='M13.6912 18.3574H9.94836C9.67147 18.3574 9.44727 18.5816 9.44727 18.8585C9.44727 19.1353 9.67147 19.3596 9.94836 19.3596H13.6912C17.1401 19.3596 19.9438 22.1557 19.9438 25.6116V26.3359C19.9438 26.6128 20.168 26.837 20.4449 26.837C20.7218 26.837 20.946 26.6128 20.946 26.3359V25.6116C20.946 21.5915 17.6855 18.3574 13.6912 18.3574Z'
        fill='url(#paint4_linear_17577_24580)'
      />
      <path
        d='M11.8169 17.8463L13.0188 11.8727H21.3578L22.8684 17.8157C23.0777 17.6702 23.3252 17.5809 23.5803 17.5554L22.1335 11.8727H22.2637C22.5571 11.8727 22.7995 11.638 22.7995 11.3395C22.7995 10.357 21.9983 9.55585 21.0108 9.55585H13.2127C12.2351 9.55585 11.4239 10.3542 11.4239 11.3395C11.4239 11.638 11.6663 11.8727 11.9598 11.8727H12.2507L11.0488 17.8463H11.8169Z'
        fill='url(#paint5_linear_17577_24580)'
      />
      <path
        d='M29.0154 23.9959C27.2343 23.9959 25.79 25.4402 25.79 27.2162C25.79 28.9999 27.2343 30.4441 29.0154 30.4441C30.7939 30.4441 32.2382 28.9999 32.2382 27.2162C32.2382 25.4402 30.7939 23.9959 29.0154 23.9959ZM29.0154 28.8391C28.1198 28.8391 27.3925 28.1119 27.3925 27.2188C27.3925 26.3231 28.1198 25.5958 29.0154 25.5958C29.9085 25.5958 30.6383 26.3231 30.6383 27.2188C30.6383 28.1119 29.9085 28.8391 29.0154 28.8391Z'
        fill='url(#paint6_linear_17577_24580)'
      />
      <path
        d='M13.7972 20.1913C10.9648 20.1913 8.67334 22.4828 8.67334 25.3152C8.67334 28.1475 10.9648 30.439 13.7972 30.439C16.6245 30.439 18.9159 28.1476 18.9159 25.3152C18.9159 22.4828 16.6245 20.1913 13.7972 20.1913ZM13.7947 27.8924C12.3734 27.8924 11.2174 26.7365 11.2174 25.3152C11.2174 23.8939 12.3734 22.7379 13.7947 22.7379C15.216 22.7379 16.3719 23.8939 16.3719 25.3152C16.3719 26.7365 15.216 27.8924 13.7947 27.8924Z'
        fill='url(#paint7_linear_17577_24580)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_17577_24580'
        x1='15.2158'
        y1='15.0852'
        x2='15.2158'
        y2='18.349'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_17577_24580'
        x1='21.0046'
        y1='15.7214'
        x2='21.0046'
        y2='18.7089'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_17577_24580'
        x1='27.3328'
        y1='14.8276'
        x2='27.3328'
        y2='17.5478'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_17577_24580'
        x1='26.4165'
        y1='18.0581'
        x2='26.4165'
        y2='26.3359'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_17577_24580'
        x1='15.1966'
        y1='18.3574'
        x2='15.1966'
        y2='26.837'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_17577_24580'
        x1='17.3146'
        y1='9.55585'
        x2='17.3146'
        y2='17.8463'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint6_linear_17577_24580'
        x1='29.0141'
        y1='23.9959'
        x2='29.0141'
        y2='30.4441'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <linearGradient
        id='paint7_linear_17577_24580'
        x1='13.7946'
        y1='20.1913'
        x2='13.7946'
        y2='30.439'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
      <clipPath id='clip0_17577_24580'>
        <rect
          width='24'
          height='24'
          fill='white'
          transform='translate(8.6665 8)'
        />
      </clipPath>
    </defs>
  </svg>
);

export const IconBug = ({
  width = 20,
  height = 21,
  color = 'currentColor',
}) => (
  <svg
    width='41'
    height='40'
    viewBox='0 0 41 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4.3335 0.5H36.3335C38.2665 0.5 39.8335 2.067 39.8335 4V36C39.8335 37.933 38.2665 39.5 36.3335 39.5H4.3335C2.4005 39.5 0.833496 37.933 0.833496 36V4C0.833497 2.067 2.4005 0.5 4.3335 0.5Z'
      fill='white'
    />
    <path
      d='M4.3335 0.5H36.3335C38.2665 0.5 39.8335 2.067 39.8335 4V36C39.8335 37.933 38.2665 39.5 36.3335 39.5H4.3335C2.4005 39.5 0.833496 37.933 0.833496 36V4C0.833497 2.067 2.4005 0.5 4.3335 0.5Z'
      stroke='#EEF2F6'
    />
    <path
      d='M32.1217 21.0313L30.71 19.4324C30.5829 19.2885 30.3994 19.1925 30.2158 19.1925H28.0982V17.2898L30.5264 15.9147C30.7664 15.7868 30.9217 15.499 30.9217 15.1952V12.7968C30.9217 12.3491 30.6111 11.9973 30.2158 11.9973C29.8206 11.9973 29.51 12.3491 29.51 12.7968V14.6995L28.0135 15.547C27.477 11.2938 24.2441 8 20.3335 8C16.4229 8 13.19 11.2938 12.6535 15.547L11.157 14.6995V12.7968C11.157 12.3491 10.8464 11.9973 10.4511 11.9973C10.0558 11.9973 9.74526 12.3491 9.74526 12.7968V15.1952C9.74526 15.499 9.90056 15.7708 10.1406 15.9147L12.5688 17.2898V19.1925H10.4511C10.2676 19.1925 10.0841 19.2725 9.95703 19.4324L8.54526 21.0313C8.26291 21.3511 8.26291 21.8468 8.54526 22.1666C8.82761 22.4863 9.26526 22.4863 9.54761 22.1666L10.7476 20.8075H12.5688V22.7102L10.1406 24.0853C9.90056 24.2132 9.74526 24.501 9.74526 24.8048V27.2032C9.74526 27.6509 10.0558 28.0027 10.4511 28.0027C10.8464 28.0027 11.157 27.6509 11.157 27.2032V25.3005L12.6535 24.453C13.19 28.7062 16.4229 32 20.3335 32C24.2441 32 27.477 28.7062 28.0135 24.453L29.51 25.3005V27.2032C29.51 27.6509 29.8206 28.0027 30.2158 28.0027C30.6111 28.0027 30.9217 27.6509 30.9217 27.2032V24.8048C30.9217 24.501 30.7664 24.2292 30.5264 24.0853L28.0982 22.7102V20.8075H29.9194L31.1194 22.1666C31.4017 22.4863 31.8394 22.4863 32.1217 22.1666C32.4041 21.8468 32.4041 21.3511 32.1217 21.0313ZM24.5688 17.5936C24.1735 17.5936 23.8629 17.2418 23.8629 16.7941C23.8629 14.5876 22.2817 12.7968 20.3335 12.7968C19.9382 12.7968 19.6276 12.445 19.6276 11.9973C19.6276 11.5496 19.9382 11.1979 20.3335 11.1979C23.0582 11.1979 25.2747 13.7082 25.2747 16.7941C25.2747 17.2418 24.9641 17.5936 24.5688 17.5936Z'
      fill='url(#paint0_linear_17577_24596)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_17577_24596'
        x1='20.3335'
        y1='8'
        x2='20.3335'
        y2='32'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
    </defs>
  </svg>
);

export const IconRoadside = ({
  width = 40,
  height = 40,
  color = 'currentColor',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4 0.5H36C37.933 0.5 39.5 2.067 39.5 4V36C39.5 37.933 37.933 39.5 36 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4C0.500001 2.067 2.067 0.5 4 0.5Z'
      fill='white'
    />
    <path
      d='M4 0.5H36C37.933 0.5 39.5 2.067 39.5 4V36C39.5 37.933 37.933 39.5 36 39.5H4C2.067 39.5 0.5 37.933 0.5 36V4C0.500001 2.067 2.067 0.5 4 0.5Z'
      stroke='#EEF2F6'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      transform='translate(8 12.08) scale(0.035527) translate(-174.867 -270)'
      d='M357.57 271.1q.67 1.1-1.26.5c-1.4-.45-3.19.53-6.38 3.5-2.44 2.26-3.75 3.8-2.93 3.43s.6.05-.5.94c-1.85 1.5-2 2.82-2 17.82v16.21l34.2.26 34.18.27 2.26 3.23c1.25 1.78 2.74 3.56 3.31 3.95.58.4 1.05 1.1 1.05 1.57 0 1.46 10.59 17.22 11.57 17.22.51 0 .88.34.81.75-.32 2.03.38 3.36 3.37 6.37 1.79 1.8 2.64 2.9 1.89 2.45s1.46 3.4 4.91 8.55 6.89 9.75 7.63 10.2 1.12 1.19.83 1.66.94 2.33 2.73 4.13c1.8 1.8 2.65 2.91 1.9 2.46q-1.32-.8.37 1.8c.95 1.45 2.14 2.63 2.66 2.63s.69.42.37.94c-.32.51.07 1.3.87 1.75s1.45 1.04 1.45 1.31c.03 1.66 1.49 3.9 2.25 3.44.49-.3.89.28.89 1.31s1 2.94 2.22 4.26c1.22 1.3 2.3 2.88 2.38 3.49.21 1.41 15.55 23.89 16.62 24.33.43.19.57.7.3 1.13s.72 2.08 2.18 3.66c1.47 1.59 2.53 3.05 2.35 3.25s.99 1.76 2.57 3.45 2.26 2.7 1.5 2.24c-1.62-.99 7.53 12.6 9.22 13.67.64.4.82.75.4.75-1.09.03 6.36 11.02 7.46 11.02.5 0 .64.45.3 1-.35.56.07 1.28.93 1.61s1.33.97 1.04 1.43c-.28.46.28 1.3 1.26 1.87.97.56 1.4 1.04.95 1.06-1.05.04 3.01 5.98 5.73 8.37 1.15 1 1.48 1.51.74 1.12-.93-.48-.81.13.36 1.92.95 1.44 2.12 2.62 2.6 2.62.5 0 .78.34.65.75-.36 1.13 7.25 13.25 8.31 13.25.51 0 .84.34.72.75-.1.41.5 2.1 1.36 3.75 2.53 4.84 3 8.22 3.24 22.82.16 10.6.54 14.02 1.62 14.68.77.48 16.16.84 34.2.8l32.81-.05-.16-26.58c-.16-26.24-.74-33.3-2.81-33.99-.59-.2-.84-.7-.57-1.14s-1.45-2.88-3.82-5.43-4.16-4.77-3.98-4.96c.18-.18-.57-1.15-1.67-2.14s-2.01-1.42-2.01-.93-.79-.54-1.75-2.28c-.96-1.75-4.52-6.24-7.91-9.99a663 663 0 0 1-10.43-11.81c-2.34-2.75-4.67-4.88-5.16-4.73-.5.16-.64-.14-.32-.65.32-.52-.81-2.1-2.5-3.53-1.7-1.42-2.81-2.59-2.48-2.59.32 0-3.98-5.29-9.56-11.75-11.16-12.92-12.6-14.5-11.38-12.35q.81 1.42-.37.69c-.65-.4-.93-1.12-.63-1.6.29-.48-.26-1.33-1.24-1.9-.97-.56-1.34-1.04-.82-1.06s-.64-1.72-2.59-3.78A1156 1156 0 0 1 516.51 374a1302 1302 0 0 0-18.64-21.5 1232 1232 0 0 1-18.92-22c-8.85-10.45-17.18-20-18.52-21.2-1.34-1.21-2.44-2.56-2.45-3 0-.44-2.93-3.92-6.5-7.74s-6.48-7.1-6.48-7.31c0-1.1-14.38-16.7-15.19-16.48-.53.16-.7-.13-.4-.63.7-1.12-1.84-3.38-2.75-2.46-.36.36-.66.13-.66-.51 0-.87-8.9-1.17-34.56-1.17-25.01 0-34.37.3-33.87 1.1m-1.83 50.65c-2.03.46-2.68 55.55-.68 56.79.54.33.71 1.02.4 1.53-.32.51-.1.93.48.93s1 .34.94.75c-.33 2.12.37 3.58 2.87 5.96 1.51 1.44 2.07 2.28 1.25 1.87s-.23.43 1.32 1.85c1.56 1.43 3.31 2.3 3.9 1.93.63-.39.8-.2.4.44-.74 1.2 2.73 3.52 3.75 2.5.35-.35.63-.08.63.6s.45.94 1 .6 1-.07 1 .6c0 .68.3.94.65.58s1.22.13 1.92 1.09c.7.95 1.87 1.73 2.6 1.73s1.35.45 1.37 1 .77 2.37 1.67 4.04c6.78 12.68-2.43 27.14-17.13 26.88-7.7-.13-17.1-6.67-17.93-12.47-.2-1.35-.76-2.7-1.26-3.01-.52-.33-.31-2.55.49-5.2.76-2.55 1.14-4.88.84-5.19-.3-.3.05-.55.78-.55s1.04-.3.68-.65.05-1.16.9-1.79c1.3-.94 1.38-1.87.5-5.6-.58-2.45-1.2-7.95-1.36-12.22s-.73-7.75-1.26-7.74c-2.24.05-4.45 1.21-3.92 2.06.3.5-.05.68-.8.4-1.52-.59-8.24 4.36-10.63 7.82a33 33 0 0 1-2.82 3.54 4.9 4.9 0 0 0-1.38 4.5c.07.46-.3.55-.85.22-1.2-.74-4.06 8.69-4.58 15.07-.48 5.88 1.2 15.17 3.32 18.39.9 1.38 1.55 2.84 1.42 3.25-.12.41.26.75.84.75s.82.38.53.85c-.77 1.26 4.63 8.2 9.34 11.98 20.14 16.18 50.43 11.42 64.24-10.09 1.7-2.64 3.08-5.9 3.08-7.25s.35-2.24.78-1.97.53-.49.22-1.67c-.36-1.36-.18-1.92.48-1.52 1.45.9 2.62-9.38 1.66-14.63-.42-2.31-.65-4.8-.5-5.55.14-.8-.23-1.06-.9-.64-.75.46-1.04.03-.83-1.2.37-2.18-3.03-10.31-4.31-10.31-.47 0-.85-.44-.85-.98 0-1.01-6.6-7.97-10.92-11.53-1.54-1.26-2.12-1.44-1.6-.49.45.82-.17.49-1.37-.75s-2.55-2.25-3-2.25c-1.9 0-5.48-4.26-5.67-6.77-.11-1.5-.29-13.21-.39-26.02l-.19-23.29-9.68.21c-5.32.12-10.47.4-11.44.62m364.92 7.08c-1.77 1.95-2.5 25.3-.87 27.86 2.44 3.85 10.1 3.02 10.93-1.19 1.4-7.06.54-25.83-1.24-27.14-2.62-1.92-6.87-1.69-8.83.47m-49.7 17.72c-3.28 3.96-1.7 7.33 7.76 16.54 9.28 9.04 8.94 8.87 15.7 8.02.51-.06.62-.41.25-.78-.36-.37.08-1.5 1-2.5 2.34-2.6 1.23-4.45-8.55-14.34-8.85-8.95-13-10.73-16.15-6.94m91.95 7.21c-9.14 9.3-10.63 12.68-7.26 16.4 3.3 3.65 13.35-.88 13.35-6.02 0-.69.37-1.03.83-.74.46.28 3.05-1.78 5.75-4.59s4.25-4.77 3.42-4.38c-.92.44-.83.17.25-.72 3.51-2.88.41-8.72-4.62-8.7-2.6.01-4.56 1.48-11.72 8.75m-43.26 14.2c-2.12.42-4.15 1.16-4.5 1.65a3.7 3.7 0 0 1-1.97 1.16c-2.41.5-6.17 3.43-5.6 4.36.31.5.02.8-.65.64-3.13-.7-6.57 9.37-6.5 19 .04 5.08-.27 9.23-.68 9.23-1.29 0-.82 4.65.5 4.98.69.17 12.44.46 26.13.63l24.87.32-.43-11.31c-.38-9.79-.8-12.07-3.18-16.92-2.67-5.47-9.9-12.27-11.8-11.1-.46.28-.84.01-.84-.6 0-.62-.41-.86-.91-.55s-1.07.17-1.25-.3c-.5-1.3-8.8-2.05-13.2-1.19m-54.39 54.01c-2.38 1.08-4.75 3.04-5.4 4.45-.63 1.38-1.47 2.31-1.88 2.06-3.01-1.86-3.43 6.3-3.2 63.71.12 31.74-.16 57.93-.62 58.22s-32.62.57-71.46.64c-38.85.07-70.57.42-70.5.79.07.36-.39 1.93-1.03 3.48a16 16 0 0 0-1.17 4c-.02 2.88-5.28 12.08-9.47 16.56-4.07 4.34-4.42 5.08-3.1 6.4.81.81 1.2 1.76.87 2.1-.35.34-.17.62.38.62s1.05.56 1.11 1.25 1.34 5.08 2.83 9.75c2.58 8.08 2.74 9.8 3.3 35l.59 26.5 82.1.23 82.1.24 1.7-8.72c1.82-9.25 5.58-19.17 9.77-25.75 1.4-2.2 2.53-4.23 2.51-4.5-.01-.27 1.33-1.85 2.98-3.51 1.66-1.65 3.2-3.46 3.43-4.01.22-.56 3.2-3.09 6.6-5.63 3.42-2.54 6-4.9 5.76-5.24q-.37-.51.14-.19c.32.24 3.59-1.11 7.25-3 3.66-1.87 7.22-3.41 7.91-3.41s1.25-.49 1.25-1.07.39-.82.86-.53c.47.3 2.38.05 4.25-.53 4.05-1.27 28.9-2.7 28.24-1.63-.43.69 2.99 1.19 6.63.98.82-.05 1.72.24 2 .64.81 1.15 10.37 4.59 11.87 4.27.74-.15 1.07.17.74.72s.3 1.29 1.41 1.64c1.12.36 4.1 2.22 6.62 4.15 2.52 1.92 4.23 2.9 3.78 2.17-1.52-2.51 11.1 11.44 12.95 14.3 1.72 2.68 3.63 4.28 2.05 1.73-.43-.7-.27-.89.4-.47.61.38.9 1.25.63 1.94-.26.69.32 2.15 1.3 3.25.97 1.1 1.85 2.44 1.94 2.97.1.53 1.18 3.21 2.4 5.96 2.55 5.7 2.49 5.46 4.27 15.5l1.33 7.5 7.16-.2c9.84-.27 22.17-6.33 22.17-10.89 0-.77.4-1.41.9-1.41.48 0 1.72-1.91 2.74-4.25 3.76-8.6 3.1-125.75-.71-125.75-.51 0-.82-.34-.7-.75.4-1.26-2.41-7.25-3.18-6.78-.4.24-.72-.1-.73-.76 0-.67-6.54-11.78-14.52-24.71a9273 9273 0 0 1-20.8-33.82c-3.45-5.67-6.92-10.96-7.7-11.75-.8-.79-1.15-1.43-.8-1.43s-.35-1.39-1.56-3.09c-2.62-3.67-9.82-9.1-11.07-8.33-.48.3-.87.08-.87-.47 0-3.84-110.46-4.9-118.75-1.14m34.54 25.32a5.3 5.3 0 0 0-3.33 3.89c-.34 1.55-.92 2.82-1.29 2.82s-.67 13.28-.67 29.5c0 16.23.34 29.5.75 29.5s.75.6.75 1.33c0 1.58 3.73 5.1 6.42 6.05 2.05.73 112.65.88 113.38.15.24-.23-1.7-4.12-4.3-8.62s-4.81-8.84-4.93-9.63a3.4 3.4 0 0 0-1.31-2.12 4 4 0 0 1-1.43-2.17c-.18-.81-1-2.08-1.83-2.81-1.33-1.18-1.33-1.26 0-.68 1.11.48 1.08.3-.15-.71-2.1-1.73-14.18-21.68-14.18-23.4 0-.72-.33-1.1-.72-.86-.4.25-1.3-1.01-2.03-2.8-.72-1.77-1.56-3.46-1.87-3.73a85 85 0 0 1-4.23-6.12c-2.8-4.28-4.94-6.26-8.94-8.25L764.6 446l-31.06.1c-19.5.07-32.06.51-33.76 1.19m-424.29 30.4c-7.23.93-13.5 2.53-13.5 3.44 0 .54-.42.73-.93.42-1.12-.7-6.07 1.43-6.07 2.61 0 .46-.34.79-.75.72-2.18-.34-3.65.42-6.49 3.37-1.72 1.79-2.54 2.35-1.82 1.25.71-1.1-1 .4-3.83 3.33-2.82 2.93-4.87 5.74-4.56 6.25s.1.92-.47.92c-1.76 0-12.97 26.2-14.43 33.71a27 27 0 0 1-1.39 4.29l-2.4 5.83-1.37 3.32-3.3-4.68c-1.82-2.58-3.54-4.45-3.83-4.16s-1.42-.37-2.52-1.47-2.66-1.74-3.47-1.43-1.23.18-.94-.3-.86-1.15-2.57-1.49c-4.52-.9-13.86-.76-13.86.21 0 .46-.58.84-1.28.84-2 0-6.77 3.44-6.15 4.44.3.49.08.89-.48.89-2.96 0-4.22 6.58-3.21 16.75.25 2.57 7.83 9.3 9.68 8.59 1.3-.5 1.55-.33.95.65-.61.99-.29 1.18 1.29.77 1.16-.3 2.24-.15 2.4.34.17.49 3.17 1.1 6.68 1.36 8.24.6 8.26.65 2.5 6.08-2.68 2.53-4.2 4.26-3.38 3.84.82-.43-.04.77-1.91 2.66-11.36 11.44-13.05 21.36-13.07 76.74-.02 46.73.55 53.84 4.11 51.64.7-.43.91-.3.54.31-.36.57.1 1.66 1.03 2.4 1.45 1.18 1.58 1.16.92-.13-.46-.9-.2-.8.66.23.78.96 1.71 1.45 2.07 1.09s.65-.13.65.51c0 2 41.41 1.62 43.43-.4.86-.87 1.57-1.25 1.57-.85s.96-.13 2.14-1.18c3.4-3.03 4.86-7.78 4.86-15.87V688h180v6.25c.01 6.94 1.55 13.75 3.1 13.75.56 0 .78.39.48.87-.3.47.36 1.67 1.44 2.65 1.1.99 1.98 1.46 1.98 1.06s.68-.04 1.5.78c1.75 1.75 45.15 2.5 44.08.77-.31-.5.13-1.19.98-1.51.96-.37 1.29-.19.87.5-.37.6.5.31 1.95-.63 2.46-1.62 3.87-3.38 1.55-1.94-.6.36-.5-.25.2-1.38s1.7-1.77 2.23-1.45c.52.32.65.1.28-.5s-.21-1.36.34-1.71c1.77-1.1 1.32-94.62-.5-102.3-1.62-6.88-4.99-14.27-7.07-15.49-.73-.42-1.1-1.35-.83-2.06s-2.32-4.36-5.75-8.1c-6.19-6.76-8.19-10.3-5.16-9.13 2.12.8 14.64-1.3 15.44-2.61.37-.6 1.1-.81 1.63-.48.52.32 2.37-.8 4.1-2.5 2.9-2.82 3.33-3.6 3.08-5.48-.05-.35.48-1 1.19-1.43 1.6-.98 1.6-11.2 0-11.73-.62-.2-.88-.77-.58-1.25.72-1.16-7.34-9.19-8.5-8.47-.49.3-1.17.1-1.52-.46-3.76-6.08-31.39 5.93-28.85 12.53q.54 1.45-.8.95c-.75-.29-3.81-7.47-6.81-15.95s-5.85-15.17-6.32-14.88c-.48.3-.72-.08-.55-.82.5-2.23-2.4-9.84-3.5-9.15-.62.38-.77-.03-.38-1.04.36-.95.15-1.66-.5-1.66-.62 0-.85-.28-.5-.63 3.08-3.08-20.42-23.33-25.55-22-1.08.27-1.5.03-1.09-.63.41-.67.08-.85-.87-.49-.85.33-1.95.2-2.44-.3-2.46-2.46-109.4-4.38-125.85-2.26m25.48 19.63c-.29.3-6.98.65-14.87.76-11.46.17-15.1.58-18.07 2.02a36 36 0 0 1-5.13 2.1c-.78.16-1.64.6-1.92.97-.28.36-2.21 2.02-4.3 3.68s-3.76 3.28-3.72 3.6c.04.31-.58 1.83-1.38 3.38s-3.34 7.95-5.65 14.24c-2.3 6.28-4.52 11.65-4.92 11.93s-.72 1.17-.72 2c-.01 2.13-5.54 17.44-6.44 17.82-.41.17-.5.95-.2 1.75.84 2.18 198.34 2.16 198.34-.03 0-.8-1.09-4.45-2.42-8.12s-2.16-7.4-1.84-8.3c.32-.89.2-1.28-.25-.86-.97.87-9.71-22.1-8.9-23.4.29-.47.08-.86-.46-.86-.94 0-2.1-2.56-2.55-5.66-.53-3.63-11.44-12.22-18.27-14.38-6.6-2.1-94.56-4.5-96.33-2.64M428.83 599.9c-.18.5-1.45 1.07-2.83 1.25-1.37.2-2.73.59-3 .88s-2.5 1.98-4.94 3.75c-2.44 1.76-4.56 3.77-4.7 4.47-.48 2.3-2.98 8.7-3.68 9.4-1.02 1.02-.82 7.56.21 6.92.49-.3 1.17.94 1.51 2.78.87 4.58 6.56 10.91 11.77 13.06 2.38.99 5.11 2.2 6.07 2.7 2.3 1.18 5.5 1.13 6.26-.11.34-.55 1.43-1 2.42-1s3.47-1.13 5.51-2.52c2.04-1.38 3.38-1.94 2.99-1.25-.4.7.19.37 1.31-.73s1.99-2.23 1.93-2.5.77-1.81 1.84-3.42c2.65-3.97 3.23-14.73 1.07-19.83-.88-2.05-1.47-3.97-1.33-4.24.6-1.17-9.92-7.57-14.77-8.98-6.12-1.77-7.18-1.86-7.64-.62m-202.52 1.9c-13.53 5.5-18.9 24.14-9.84 34.15.76.85 1.42 1.88 1.46 2.29s.18.64.32.5c.14-.13 1.68.77 3.42 2.01a20 20 0 0 0 6.25 2.87c1.7.34 3.08.92 3.08 1.28s1.13.75 2.5.86 2.5-.18 2.5-.65 1.7-1.14 3.8-1.47c11.88-1.9 19.69-18.37 14.31-30.2-1.88-4.14-9.4-11.45-11.79-11.45-.73 0-1.32-.35-1.32-.78 0-1.54-10.51-1.1-14.7.6m506.45 10.83c-1.51.27-2.75.93-2.75 1.48 0 .57-.92.71-2.12.33-1.37-.43-1.9-.3-1.48.37.36.59-.14 1.02-1.13.97-2.59-.1-7.27 1.98-7.27 3.23 0 .6-.45.81-1 .47-.54-.34-2.12.6-3.5 2.09s-2.5 2.36-2.5 1.93-.67-.2-1.49.47c-.82.68-1.26 1.6-.98 2.05.27.45-.02 1.15-.67 1.55q-1.16.72-.44-.69c.4-.77-.22-.27-1.38 1.1-4.57 5.4-6.54 8.06-6.47 8.76.04.4-.52 1.33-1.24 2.05-3.21 3.21-5.6 15.04-5.08 25.04.54 10.07 3.98 21.75 6.03 20.47.57-.34.74-.16.38.41-1.55 2.52 13.33 18.31 18.32 19.44.8.18 2.1.92 2.88 1.64s2.01 1.07 2.77.78c.75-.29 1.37-.07 1.37.5s.42.77.93.45a1.1 1.1 0 0 1 1.5.34c1.67 2.71 24.53 3.62 26.12 1.03.29-.45 1.18-.57 1.98-.26s1.47.04 1.47-.6.4-.92.88-.62c1.4.86 7.19-1.51 6.48-2.66-.36-.58-.03-.82.75-.55 2.84.99 17.87-11.83 16.49-14.06-.35-.56-.1-1.35.54-1.75q1.1-.67.46.44c-.4.63-.49 1.15-.2 1.15 1.2 0 5.7-9.04 5.02-10.12q-.72-1.17.53-.4c.94.57 1.08.2.55-1.48-.42-1.34-.33-2.01.23-1.67 1.35.84 3.27-8.39 3.27-15.73 0-10.7-5.96-25.86-12.24-31.15-1.6-1.35-2.61-2.45-2.24-2.45.84 0-7.21-6.76-9.53-8-.95-.51-2.01-.64-2.36-.3s-.63.16-.63-.41c0-1.01-4.31-3.21-7.13-3.64-.75-.11-2-.6-2.76-1.07-1.57-.98-18.12-1.66-22.36-.93m.15 29.3c-4.36 2.35-9.64 8.17-10.5 11.57-.34 1.36-.93 2.48-1.31 2.48-.63 0 .14 10.37 1.04 14 .63 2.57 9.96 11.14 12.9 11.86 8.92 2.17 16.44.52 22.1-4.87 2.13-2.02 3.91-3.41 3.96-3.09s.71-1.65 1.48-4.4c3.43-12.32.74-19.18-11.1-28.37-2.24-1.74-14.85-1.17-18.57.83'
      fill='url(#paint0_linear_roadside_cat)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_roadside_cat'
        x1='0'
        y1='0'
        x2='0'
        y2='1'
      >
        <stop stopColor='#202939' />
        <stop offset='1' stopColor='#444CE7' />
      </linearGradient>
    </defs>
  </svg>
);
